export interface UploadHistoryResponse {
  id: string
  account_name: string
  account_number_last_four: string
  uploaded_by: string
  bank_account_id: string
  file_path: string
  uploaded_at: string
  total_records: number
  unique_records: number
  status: string
  error_message: string | null
  last_transaction_date: string | null
  first_transaction_date: string | null
}

export class uploadHistory {
  id: string
  accountName: string
  accountNumber: string
  uploadedBy: string
  bankAccountId: string
  filePath: string
  uploadedAt: string
  totalRecords: number
  uniqueRecords: number
  status: string
  errorMessage: string | null
  lastTransactionDate: string | null
  firstTransactionDate: string | null

  constructor(data?: UploadHistoryResponse) {
    this.id = data?.id ?? ""
    this.accountName = data?.account_name ?? ""
    this.accountNumber = data?.account_number_last_four ?? ""
    this.uploadedBy = data?.uploaded_by ?? ""
    this.bankAccountId = data?.bank_account_id ?? ""
    this.filePath = data?.file_path ?? ""
    this.uploadedAt = data?.uploaded_at ?? ""
    this.totalRecords = data?.total_records ?? 0
    this.uniqueRecords = data?.unique_records ?? 0
    this.status = data?.status ?? ""
    this.errorMessage = data?.error_message ?? null
    this.lastTransactionDate = data?.last_transaction_date ?? null
    this.firstTransactionDate = data?.first_transaction_date ?? null
  }
}

export interface UploadLogData {
  uploaded_by: string
  account_name: string
  bank_account_id: string
  file_path: string
  uploaded_at: string
  total_records: number
  unique_records: number
  status: string
  error_message: string | null
  last_transaction_date: string
  first_transaction_date: string
}

export class UploadLog {
  uploadedBy: string
  accountName: string
  bankAccountId: string
  filePath: string
  uploadedAt: string
  totalRecords: number
  uniqueRecords: number
  status: string
  errorMessage: string | null
  lastTransactionDate: string
  firstTransactionDate: string

  constructor(data?: UploadLogData) {
    this.uploadedBy = data?.uploaded_by ?? ""
    this.accountName = data?.account_name ?? ""
    this.bankAccountId = data?.bank_account_id ?? ""
    this.filePath = data?.file_path ?? ""
    this.uploadedAt = data?.uploaded_at ?? ""
    this.totalRecords = data?.total_records ?? 0
    this.uniqueRecords = data?.unique_records ?? 0
    this.status = data?.status ?? ""
    this.errorMessage = data?.error_message ?? null
    this.lastTransactionDate = data?.last_transaction_date ?? ""
    this.firstTransactionDate = data?.first_transaction_date ?? ""
  }
}
